import { __assign } from "tslib";
export var AccessDeniedException;
(function (AccessDeniedException) {
    AccessDeniedException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AccessDeniedException || (AccessDeniedException = {}));
export var AgeRange;
(function (AgeRange) {
    AgeRange.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AgeRange || (AgeRange = {}));
export var S3Object;
(function (S3Object) {
    S3Object.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(S3Object || (S3Object = {}));
export var GroundTruthManifest;
(function (GroundTruthManifest) {
    GroundTruthManifest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GroundTruthManifest || (GroundTruthManifest = {}));
export var Asset;
(function (Asset) {
    Asset.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Asset || (Asset = {}));
export var Attribute;
(function (Attribute) {
    Attribute["ALL"] = "ALL";
    Attribute["DEFAULT"] = "DEFAULT";
})(Attribute || (Attribute = {}));
export var AudioMetadata;
(function (AudioMetadata) {
    AudioMetadata.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AudioMetadata || (AudioMetadata = {}));
export var Beard;
(function (Beard) {
    Beard.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Beard || (Beard = {}));
export var BodyPart;
(function (BodyPart) {
    BodyPart["FACE"] = "FACE";
    BodyPart["HEAD"] = "HEAD";
    BodyPart["LEFT_HAND"] = "LEFT_HAND";
    BodyPart["RIGHT_HAND"] = "RIGHT_HAND";
})(BodyPart || (BodyPart = {}));
export var BoundingBox;
(function (BoundingBox) {
    BoundingBox.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(BoundingBox || (BoundingBox = {}));
export var CoversBodyPart;
(function (CoversBodyPart) {
    CoversBodyPart.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CoversBodyPart || (CoversBodyPart = {}));
export var ProtectiveEquipmentType;
(function (ProtectiveEquipmentType) {
    ProtectiveEquipmentType["FACE_COVER"] = "FACE_COVER";
    ProtectiveEquipmentType["HAND_COVER"] = "HAND_COVER";
    ProtectiveEquipmentType["HEAD_COVER"] = "HEAD_COVER";
})(ProtectiveEquipmentType || (ProtectiveEquipmentType = {}));
export var EquipmentDetection;
(function (EquipmentDetection) {
    EquipmentDetection.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EquipmentDetection || (EquipmentDetection = {}));
export var ProtectiveEquipmentBodyPart;
(function (ProtectiveEquipmentBodyPart) {
    ProtectiveEquipmentBodyPart.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ProtectiveEquipmentBodyPart || (ProtectiveEquipmentBodyPart = {}));
export var LandmarkType;
(function (LandmarkType) {
    LandmarkType["chinBottom"] = "chinBottom";
    LandmarkType["eyeLeft"] = "eyeLeft";
    LandmarkType["eyeRight"] = "eyeRight";
    LandmarkType["leftEyeBrowLeft"] = "leftEyeBrowLeft";
    LandmarkType["leftEyeBrowRight"] = "leftEyeBrowRight";
    LandmarkType["leftEyeBrowUp"] = "leftEyeBrowUp";
    LandmarkType["leftEyeDown"] = "leftEyeDown";
    LandmarkType["leftEyeLeft"] = "leftEyeLeft";
    LandmarkType["leftEyeRight"] = "leftEyeRight";
    LandmarkType["leftEyeUp"] = "leftEyeUp";
    LandmarkType["leftPupil"] = "leftPupil";
    LandmarkType["midJawlineLeft"] = "midJawlineLeft";
    LandmarkType["midJawlineRight"] = "midJawlineRight";
    LandmarkType["mouthDown"] = "mouthDown";
    LandmarkType["mouthLeft"] = "mouthLeft";
    LandmarkType["mouthRight"] = "mouthRight";
    LandmarkType["mouthUp"] = "mouthUp";
    LandmarkType["nose"] = "nose";
    LandmarkType["noseLeft"] = "noseLeft";
    LandmarkType["noseRight"] = "noseRight";
    LandmarkType["rightEyeBrowLeft"] = "rightEyeBrowLeft";
    LandmarkType["rightEyeBrowRight"] = "rightEyeBrowRight";
    LandmarkType["rightEyeBrowUp"] = "rightEyeBrowUp";
    LandmarkType["rightEyeDown"] = "rightEyeDown";
    LandmarkType["rightEyeLeft"] = "rightEyeLeft";
    LandmarkType["rightEyeRight"] = "rightEyeRight";
    LandmarkType["rightEyeUp"] = "rightEyeUp";
    LandmarkType["rightPupil"] = "rightPupil";
    LandmarkType["upperJawlineLeft"] = "upperJawlineLeft";
    LandmarkType["upperJawlineRight"] = "upperJawlineRight";
})(LandmarkType || (LandmarkType = {}));
export var Landmark;
(function (Landmark) {
    Landmark.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Landmark || (Landmark = {}));
export var Pose;
(function (Pose) {
    Pose.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Pose || (Pose = {}));
export var ImageQuality;
(function (ImageQuality) {
    ImageQuality.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ImageQuality || (ImageQuality = {}));
export var ComparedFace;
(function (ComparedFace) {
    ComparedFace.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ComparedFace || (ComparedFace = {}));
export var Celebrity;
(function (Celebrity) {
    Celebrity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Celebrity || (Celebrity = {}));
export var Emotion;
(function (Emotion) {
    Emotion.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Emotion || (Emotion = {}));
export var Eyeglasses;
(function (Eyeglasses) {
    Eyeglasses.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Eyeglasses || (Eyeglasses = {}));
export var EyeOpen;
(function (EyeOpen) {
    EyeOpen.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EyeOpen || (EyeOpen = {}));
export var GenderType;
(function (GenderType) {
    GenderType["Female"] = "Female";
    GenderType["Male"] = "Male";
})(GenderType || (GenderType = {}));
export var Gender;
(function (Gender) {
    Gender.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Gender || (Gender = {}));
export var MouthOpen;
(function (MouthOpen) {
    MouthOpen.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MouthOpen || (MouthOpen = {}));
export var Mustache;
(function (Mustache) {
    Mustache.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Mustache || (Mustache = {}));
export var Smile;
(function (Smile) {
    Smile.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Smile || (Smile = {}));
export var Sunglasses;
(function (Sunglasses) {
    Sunglasses.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Sunglasses || (Sunglasses = {}));
export var FaceDetail;
(function (FaceDetail) {
    FaceDetail.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FaceDetail || (FaceDetail = {}));
export var CelebrityDetail;
(function (CelebrityDetail) {
    CelebrityDetail.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CelebrityDetail || (CelebrityDetail = {}));
export var CelebrityRecognition;
(function (CelebrityRecognition) {
    CelebrityRecognition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CelebrityRecognition || (CelebrityRecognition = {}));
export var CelebrityRecognitionSortBy;
(function (CelebrityRecognitionSortBy) {
    CelebrityRecognitionSortBy["ID"] = "ID";
    CelebrityRecognitionSortBy["TIMESTAMP"] = "TIMESTAMP";
})(CelebrityRecognitionSortBy || (CelebrityRecognitionSortBy = {}));
export var ComparedSourceImageFace;
(function (ComparedSourceImageFace) {
    ComparedSourceImageFace.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ComparedSourceImageFace || (ComparedSourceImageFace = {}));
export var QualityFilter;
(function (QualityFilter) {
    QualityFilter["AUTO"] = "AUTO";
    QualityFilter["HIGH"] = "HIGH";
    QualityFilter["LOW"] = "LOW";
    QualityFilter["MEDIUM"] = "MEDIUM";
    QualityFilter["NONE"] = "NONE";
})(QualityFilter || (QualityFilter = {}));
export var Image;
(function (Image) {
    Image.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Image || (Image = {}));
export var CompareFacesRequest;
(function (CompareFacesRequest) {
    CompareFacesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CompareFacesRequest || (CompareFacesRequest = {}));
export var CompareFacesMatch;
(function (CompareFacesMatch) {
    CompareFacesMatch.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CompareFacesMatch || (CompareFacesMatch = {}));
export var OrientationCorrection;
(function (OrientationCorrection) {
    OrientationCorrection["ROTATE_0"] = "ROTATE_0";
    OrientationCorrection["ROTATE_180"] = "ROTATE_180";
    OrientationCorrection["ROTATE_270"] = "ROTATE_270";
    OrientationCorrection["ROTATE_90"] = "ROTATE_90";
})(OrientationCorrection || (OrientationCorrection = {}));
export var CompareFacesResponse;
(function (CompareFacesResponse) {
    CompareFacesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CompareFacesResponse || (CompareFacesResponse = {}));
export var ImageTooLargeException;
(function (ImageTooLargeException) {
    ImageTooLargeException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ImageTooLargeException || (ImageTooLargeException = {}));
export var InternalServerError;
(function (InternalServerError) {
    InternalServerError.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InternalServerError || (InternalServerError = {}));
export var InvalidImageFormatException;
(function (InvalidImageFormatException) {
    InvalidImageFormatException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InvalidImageFormatException || (InvalidImageFormatException = {}));
export var InvalidParameterException;
(function (InvalidParameterException) {
    InvalidParameterException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InvalidParameterException || (InvalidParameterException = {}));
export var InvalidS3ObjectException;
(function (InvalidS3ObjectException) {
    InvalidS3ObjectException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InvalidS3ObjectException || (InvalidS3ObjectException = {}));
export var ProvisionedThroughputExceededException;
(function (ProvisionedThroughputExceededException) {
    ProvisionedThroughputExceededException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ProvisionedThroughputExceededException || (ProvisionedThroughputExceededException = {}));
export var ThrottlingException;
(function (ThrottlingException) {
    ThrottlingException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ThrottlingException || (ThrottlingException = {}));
export var ContentClassifier;
(function (ContentClassifier) {
    ContentClassifier["FREE_OF_ADULT_CONTENT"] = "FreeOfAdultContent";
    ContentClassifier["FREE_OF_PERSONALLY_IDENTIFIABLE_INFORMATION"] = "FreeOfPersonallyIdentifiableInformation";
})(ContentClassifier || (ContentClassifier = {}));
export var ModerationLabel;
(function (ModerationLabel) {
    ModerationLabel.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ModerationLabel || (ModerationLabel = {}));
export var ContentModerationDetection;
(function (ContentModerationDetection) {
    ContentModerationDetection.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ContentModerationDetection || (ContentModerationDetection = {}));
export var ContentModerationSortBy;
(function (ContentModerationSortBy) {
    ContentModerationSortBy["NAME"] = "NAME";
    ContentModerationSortBy["TIMESTAMP"] = "TIMESTAMP";
})(ContentModerationSortBy || (ContentModerationSortBy = {}));
export var CreateCollectionRequest;
(function (CreateCollectionRequest) {
    CreateCollectionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateCollectionRequest || (CreateCollectionRequest = {}));
export var CreateCollectionResponse;
(function (CreateCollectionResponse) {
    CreateCollectionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateCollectionResponse || (CreateCollectionResponse = {}));
export var ResourceAlreadyExistsException;
(function (ResourceAlreadyExistsException) {
    ResourceAlreadyExistsException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResourceAlreadyExistsException || (ResourceAlreadyExistsException = {}));
export var CreateProjectRequest;
(function (CreateProjectRequest) {
    CreateProjectRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateProjectRequest || (CreateProjectRequest = {}));
export var CreateProjectResponse;
(function (CreateProjectResponse) {
    CreateProjectResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateProjectResponse || (CreateProjectResponse = {}));
export var LimitExceededException;
(function (LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LimitExceededException || (LimitExceededException = {}));
export var ResourceInUseException;
(function (ResourceInUseException) {
    ResourceInUseException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResourceInUseException || (ResourceInUseException = {}));
export var OutputConfig;
(function (OutputConfig) {
    OutputConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(OutputConfig || (OutputConfig = {}));
export var TestingData;
(function (TestingData) {
    TestingData.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TestingData || (TestingData = {}));
export var TrainingData;
(function (TrainingData) {
    TrainingData.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TrainingData || (TrainingData = {}));
export var CreateProjectVersionRequest;
(function (CreateProjectVersionRequest) {
    CreateProjectVersionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateProjectVersionRequest || (CreateProjectVersionRequest = {}));
export var CreateProjectVersionResponse;
(function (CreateProjectVersionResponse) {
    CreateProjectVersionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateProjectVersionResponse || (CreateProjectVersionResponse = {}));
export var ResourceNotFoundException;
(function (ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
export var KinesisVideoStream;
(function (KinesisVideoStream) {
    KinesisVideoStream.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(KinesisVideoStream || (KinesisVideoStream = {}));
export var StreamProcessorInput;
(function (StreamProcessorInput) {
    StreamProcessorInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StreamProcessorInput || (StreamProcessorInput = {}));
export var KinesisDataStream;
(function (KinesisDataStream) {
    KinesisDataStream.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(KinesisDataStream || (KinesisDataStream = {}));
export var StreamProcessorOutput;
(function (StreamProcessorOutput) {
    StreamProcessorOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StreamProcessorOutput || (StreamProcessorOutput = {}));
export var FaceSearchSettings;
(function (FaceSearchSettings) {
    FaceSearchSettings.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FaceSearchSettings || (FaceSearchSettings = {}));
export var StreamProcessorSettings;
(function (StreamProcessorSettings) {
    StreamProcessorSettings.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StreamProcessorSettings || (StreamProcessorSettings = {}));
export var CreateStreamProcessorRequest;
(function (CreateStreamProcessorRequest) {
    CreateStreamProcessorRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateStreamProcessorRequest || (CreateStreamProcessorRequest = {}));
export var CreateStreamProcessorResponse;
(function (CreateStreamProcessorResponse) {
    CreateStreamProcessorResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateStreamProcessorResponse || (CreateStreamProcessorResponse = {}));
export var Point;
(function (Point) {
    Point.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Point || (Point = {}));
export var Geometry;
(function (Geometry) {
    Geometry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Geometry || (Geometry = {}));
export var CustomLabel;
(function (CustomLabel) {
    CustomLabel.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CustomLabel || (CustomLabel = {}));
export var DeleteCollectionRequest;
(function (DeleteCollectionRequest) {
    DeleteCollectionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteCollectionRequest || (DeleteCollectionRequest = {}));
export var DeleteCollectionResponse;
(function (DeleteCollectionResponse) {
    DeleteCollectionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteCollectionResponse || (DeleteCollectionResponse = {}));
export var DeleteFacesRequest;
(function (DeleteFacesRequest) {
    DeleteFacesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteFacesRequest || (DeleteFacesRequest = {}));
export var DeleteFacesResponse;
(function (DeleteFacesResponse) {
    DeleteFacesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteFacesResponse || (DeleteFacesResponse = {}));
export var DeleteProjectRequest;
(function (DeleteProjectRequest) {
    DeleteProjectRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteProjectRequest || (DeleteProjectRequest = {}));
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["CREATED"] = "CREATED";
    ProjectStatus["CREATING"] = "CREATING";
    ProjectStatus["DELETING"] = "DELETING";
})(ProjectStatus || (ProjectStatus = {}));
export var DeleteProjectResponse;
(function (DeleteProjectResponse) {
    DeleteProjectResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteProjectResponse || (DeleteProjectResponse = {}));
export var DeleteProjectVersionRequest;
(function (DeleteProjectVersionRequest) {
    DeleteProjectVersionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteProjectVersionRequest || (DeleteProjectVersionRequest = {}));
export var ProjectVersionStatus;
(function (ProjectVersionStatus) {
    ProjectVersionStatus["DELETING"] = "DELETING";
    ProjectVersionStatus["FAILED"] = "FAILED";
    ProjectVersionStatus["RUNNING"] = "RUNNING";
    ProjectVersionStatus["STARTING"] = "STARTING";
    ProjectVersionStatus["STOPPED"] = "STOPPED";
    ProjectVersionStatus["STOPPING"] = "STOPPING";
    ProjectVersionStatus["TRAINING_COMPLETED"] = "TRAINING_COMPLETED";
    ProjectVersionStatus["TRAINING_FAILED"] = "TRAINING_FAILED";
    ProjectVersionStatus["TRAINING_IN_PROGRESS"] = "TRAINING_IN_PROGRESS";
})(ProjectVersionStatus || (ProjectVersionStatus = {}));
export var DeleteProjectVersionResponse;
(function (DeleteProjectVersionResponse) {
    DeleteProjectVersionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteProjectVersionResponse || (DeleteProjectVersionResponse = {}));
export var DeleteStreamProcessorRequest;
(function (DeleteStreamProcessorRequest) {
    DeleteStreamProcessorRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteStreamProcessorRequest || (DeleteStreamProcessorRequest = {}));
export var DeleteStreamProcessorResponse;
(function (DeleteStreamProcessorResponse) {
    DeleteStreamProcessorResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteStreamProcessorResponse || (DeleteStreamProcessorResponse = {}));
export var DescribeCollectionRequest;
(function (DescribeCollectionRequest) {
    DescribeCollectionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeCollectionRequest || (DescribeCollectionRequest = {}));
export var DescribeCollectionResponse;
(function (DescribeCollectionResponse) {
    DescribeCollectionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeCollectionResponse || (DescribeCollectionResponse = {}));
export var DescribeProjectsRequest;
(function (DescribeProjectsRequest) {
    DescribeProjectsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeProjectsRequest || (DescribeProjectsRequest = {}));
export var ProjectDescription;
(function (ProjectDescription) {
    ProjectDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ProjectDescription || (ProjectDescription = {}));
export var DescribeProjectsResponse;
(function (DescribeProjectsResponse) {
    DescribeProjectsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeProjectsResponse || (DescribeProjectsResponse = {}));
export var InvalidPaginationTokenException;
(function (InvalidPaginationTokenException) {
    InvalidPaginationTokenException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InvalidPaginationTokenException || (InvalidPaginationTokenException = {}));
export var DescribeProjectVersionsRequest;
(function (DescribeProjectVersionsRequest) {
    DescribeProjectVersionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeProjectVersionsRequest || (DescribeProjectVersionsRequest = {}));
export var Summary;
(function (Summary) {
    Summary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Summary || (Summary = {}));
export var EvaluationResult;
(function (EvaluationResult) {
    EvaluationResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EvaluationResult || (EvaluationResult = {}));
export var ValidationData;
(function (ValidationData) {
    ValidationData.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ValidationData || (ValidationData = {}));
export var TestingDataResult;
(function (TestingDataResult) {
    TestingDataResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TestingDataResult || (TestingDataResult = {}));
export var TrainingDataResult;
(function (TrainingDataResult) {
    TrainingDataResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TrainingDataResult || (TrainingDataResult = {}));
export var ProjectVersionDescription;
(function (ProjectVersionDescription) {
    ProjectVersionDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ProjectVersionDescription || (ProjectVersionDescription = {}));
export var DescribeProjectVersionsResponse;
(function (DescribeProjectVersionsResponse) {
    DescribeProjectVersionsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeProjectVersionsResponse || (DescribeProjectVersionsResponse = {}));
export var DescribeStreamProcessorRequest;
(function (DescribeStreamProcessorRequest) {
    DescribeStreamProcessorRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeStreamProcessorRequest || (DescribeStreamProcessorRequest = {}));
export var StreamProcessorStatus;
(function (StreamProcessorStatus) {
    StreamProcessorStatus["FAILED"] = "FAILED";
    StreamProcessorStatus["RUNNING"] = "RUNNING";
    StreamProcessorStatus["STARTING"] = "STARTING";
    StreamProcessorStatus["STOPPED"] = "STOPPED";
    StreamProcessorStatus["STOPPING"] = "STOPPING";
})(StreamProcessorStatus || (StreamProcessorStatus = {}));
export var DescribeStreamProcessorResponse;
(function (DescribeStreamProcessorResponse) {
    DescribeStreamProcessorResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DescribeStreamProcessorResponse || (DescribeStreamProcessorResponse = {}));
export var DetectCustomLabelsRequest;
(function (DetectCustomLabelsRequest) {
    DetectCustomLabelsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectCustomLabelsRequest || (DetectCustomLabelsRequest = {}));
export var DetectCustomLabelsResponse;
(function (DetectCustomLabelsResponse) {
    DetectCustomLabelsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectCustomLabelsResponse || (DetectCustomLabelsResponse = {}));
export var ResourceNotReadyException;
(function (ResourceNotReadyException) {
    ResourceNotReadyException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResourceNotReadyException || (ResourceNotReadyException = {}));
export var DetectFacesRequest;
(function (DetectFacesRequest) {
    DetectFacesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectFacesRequest || (DetectFacesRequest = {}));
export var DetectFacesResponse;
(function (DetectFacesResponse) {
    DetectFacesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectFacesResponse || (DetectFacesResponse = {}));
export var DetectionFilter;
(function (DetectionFilter) {
    DetectionFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectionFilter || (DetectionFilter = {}));
export var DetectLabelsRequest;
(function (DetectLabelsRequest) {
    DetectLabelsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectLabelsRequest || (DetectLabelsRequest = {}));
export var Instance;
(function (Instance) {
    Instance.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Instance || (Instance = {}));
export var Parent;
(function (Parent) {
    Parent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Parent || (Parent = {}));
export var Label;
(function (Label) {
    Label.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Label || (Label = {}));
export var DetectLabelsResponse;
(function (DetectLabelsResponse) {
    DetectLabelsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectLabelsResponse || (DetectLabelsResponse = {}));
export var HumanLoopDataAttributes;
(function (HumanLoopDataAttributes) {
    HumanLoopDataAttributes.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(HumanLoopDataAttributes || (HumanLoopDataAttributes = {}));
export var HumanLoopConfig;
(function (HumanLoopConfig) {
    HumanLoopConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(HumanLoopConfig || (HumanLoopConfig = {}));
export var DetectModerationLabelsRequest;
(function (DetectModerationLabelsRequest) {
    DetectModerationLabelsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectModerationLabelsRequest || (DetectModerationLabelsRequest = {}));
export var HumanLoopActivationOutput;
(function (HumanLoopActivationOutput) {
    HumanLoopActivationOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(HumanLoopActivationOutput || (HumanLoopActivationOutput = {}));
export var DetectModerationLabelsResponse;
(function (DetectModerationLabelsResponse) {
    DetectModerationLabelsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectModerationLabelsResponse || (DetectModerationLabelsResponse = {}));
export var HumanLoopQuotaExceededException;
(function (HumanLoopQuotaExceededException) {
    HumanLoopQuotaExceededException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(HumanLoopQuotaExceededException || (HumanLoopQuotaExceededException = {}));
export var ProtectiveEquipmentSummarizationAttributes;
(function (ProtectiveEquipmentSummarizationAttributes) {
    ProtectiveEquipmentSummarizationAttributes.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ProtectiveEquipmentSummarizationAttributes || (ProtectiveEquipmentSummarizationAttributes = {}));
export var DetectProtectiveEquipmentRequest;
(function (DetectProtectiveEquipmentRequest) {
    DetectProtectiveEquipmentRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectProtectiveEquipmentRequest || (DetectProtectiveEquipmentRequest = {}));
export var ProtectiveEquipmentPerson;
(function (ProtectiveEquipmentPerson) {
    ProtectiveEquipmentPerson.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ProtectiveEquipmentPerson || (ProtectiveEquipmentPerson = {}));
export var ProtectiveEquipmentSummary;
(function (ProtectiveEquipmentSummary) {
    ProtectiveEquipmentSummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ProtectiveEquipmentSummary || (ProtectiveEquipmentSummary = {}));
export var DetectProtectiveEquipmentResponse;
(function (DetectProtectiveEquipmentResponse) {
    DetectProtectiveEquipmentResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectProtectiveEquipmentResponse || (DetectProtectiveEquipmentResponse = {}));
export var RegionOfInterest;
(function (RegionOfInterest) {
    RegionOfInterest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RegionOfInterest || (RegionOfInterest = {}));
export var DetectTextFilters;
(function (DetectTextFilters) {
    DetectTextFilters.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectTextFilters || (DetectTextFilters = {}));
export var DetectTextRequest;
(function (DetectTextRequest) {
    DetectTextRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectTextRequest || (DetectTextRequest = {}));
export var TextTypes;
(function (TextTypes) {
    TextTypes["LINE"] = "LINE";
    TextTypes["WORD"] = "WORD";
})(TextTypes || (TextTypes = {}));
export var TextDetection;
(function (TextDetection) {
    TextDetection.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TextDetection || (TextDetection = {}));
export var DetectTextResponse;
(function (DetectTextResponse) {
    DetectTextResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DetectTextResponse || (DetectTextResponse = {}));
export var Face;
(function (Face) {
    Face.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Face || (Face = {}));
export var FaceAttributes;
(function (FaceAttributes) {
    FaceAttributes["ALL"] = "ALL";
    FaceAttributes["DEFAULT"] = "DEFAULT";
})(FaceAttributes || (FaceAttributes = {}));
export var FaceDetection;
(function (FaceDetection) {
    FaceDetection.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FaceDetection || (FaceDetection = {}));
export var FaceMatch;
(function (FaceMatch) {
    FaceMatch.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FaceMatch || (FaceMatch = {}));
export var FaceRecord;
(function (FaceRecord) {
    FaceRecord.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(FaceRecord || (FaceRecord = {}));
export var FaceSearchSortBy;
(function (FaceSearchSortBy) {
    FaceSearchSortBy["INDEX"] = "INDEX";
    FaceSearchSortBy["TIMESTAMP"] = "TIMESTAMP";
})(FaceSearchSortBy || (FaceSearchSortBy = {}));
export var GetCelebrityInfoRequest;
(function (GetCelebrityInfoRequest) {
    GetCelebrityInfoRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCelebrityInfoRequest || (GetCelebrityInfoRequest = {}));
export var GetCelebrityInfoResponse;
(function (GetCelebrityInfoResponse) {
    GetCelebrityInfoResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCelebrityInfoResponse || (GetCelebrityInfoResponse = {}));
export var GetCelebrityRecognitionRequest;
(function (GetCelebrityRecognitionRequest) {
    GetCelebrityRecognitionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCelebrityRecognitionRequest || (GetCelebrityRecognitionRequest = {}));
export var VideoJobStatus;
(function (VideoJobStatus) {
    VideoJobStatus["FAILED"] = "FAILED";
    VideoJobStatus["IN_PROGRESS"] = "IN_PROGRESS";
    VideoJobStatus["SUCCEEDED"] = "SUCCEEDED";
})(VideoJobStatus || (VideoJobStatus = {}));
export var VideoMetadata;
(function (VideoMetadata) {
    VideoMetadata.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VideoMetadata || (VideoMetadata = {}));
export var GetCelebrityRecognitionResponse;
(function (GetCelebrityRecognitionResponse) {
    GetCelebrityRecognitionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCelebrityRecognitionResponse || (GetCelebrityRecognitionResponse = {}));
export var GetContentModerationRequest;
(function (GetContentModerationRequest) {
    GetContentModerationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetContentModerationRequest || (GetContentModerationRequest = {}));
export var GetContentModerationResponse;
(function (GetContentModerationResponse) {
    GetContentModerationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetContentModerationResponse || (GetContentModerationResponse = {}));
export var GetFaceDetectionRequest;
(function (GetFaceDetectionRequest) {
    GetFaceDetectionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFaceDetectionRequest || (GetFaceDetectionRequest = {}));
export var GetFaceDetectionResponse;
(function (GetFaceDetectionResponse) {
    GetFaceDetectionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFaceDetectionResponse || (GetFaceDetectionResponse = {}));
export var GetFaceSearchRequest;
(function (GetFaceSearchRequest) {
    GetFaceSearchRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFaceSearchRequest || (GetFaceSearchRequest = {}));
export var PersonDetail;
(function (PersonDetail) {
    PersonDetail.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PersonDetail || (PersonDetail = {}));
export var PersonMatch;
(function (PersonMatch) {
    PersonMatch.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PersonMatch || (PersonMatch = {}));
export var GetFaceSearchResponse;
(function (GetFaceSearchResponse) {
    GetFaceSearchResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetFaceSearchResponse || (GetFaceSearchResponse = {}));
export var LabelDetectionSortBy;
(function (LabelDetectionSortBy) {
    LabelDetectionSortBy["NAME"] = "NAME";
    LabelDetectionSortBy["TIMESTAMP"] = "TIMESTAMP";
})(LabelDetectionSortBy || (LabelDetectionSortBy = {}));
export var GetLabelDetectionRequest;
(function (GetLabelDetectionRequest) {
    GetLabelDetectionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetLabelDetectionRequest || (GetLabelDetectionRequest = {}));
export var LabelDetection;
(function (LabelDetection) {
    LabelDetection.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(LabelDetection || (LabelDetection = {}));
export var GetLabelDetectionResponse;
(function (GetLabelDetectionResponse) {
    GetLabelDetectionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetLabelDetectionResponse || (GetLabelDetectionResponse = {}));
export var PersonTrackingSortBy;
(function (PersonTrackingSortBy) {
    PersonTrackingSortBy["INDEX"] = "INDEX";
    PersonTrackingSortBy["TIMESTAMP"] = "TIMESTAMP";
})(PersonTrackingSortBy || (PersonTrackingSortBy = {}));
export var GetPersonTrackingRequest;
(function (GetPersonTrackingRequest) {
    GetPersonTrackingRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetPersonTrackingRequest || (GetPersonTrackingRequest = {}));
export var PersonDetection;
(function (PersonDetection) {
    PersonDetection.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PersonDetection || (PersonDetection = {}));
export var GetPersonTrackingResponse;
(function (GetPersonTrackingResponse) {
    GetPersonTrackingResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetPersonTrackingResponse || (GetPersonTrackingResponse = {}));
export var GetSegmentDetectionRequest;
(function (GetSegmentDetectionRequest) {
    GetSegmentDetectionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetSegmentDetectionRequest || (GetSegmentDetectionRequest = {}));
export var ShotSegment;
(function (ShotSegment) {
    ShotSegment.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ShotSegment || (ShotSegment = {}));
export var TechnicalCueType;
(function (TechnicalCueType) {
    TechnicalCueType["BLACK_FRAMES"] = "BlackFrames";
    TechnicalCueType["COLOR_BARS"] = "ColorBars";
    TechnicalCueType["END_CREDITS"] = "EndCredits";
})(TechnicalCueType || (TechnicalCueType = {}));
export var TechnicalCueSegment;
(function (TechnicalCueSegment) {
    TechnicalCueSegment.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TechnicalCueSegment || (TechnicalCueSegment = {}));
export var SegmentType;
(function (SegmentType) {
    SegmentType["SHOT"] = "SHOT";
    SegmentType["TECHNICAL_CUE"] = "TECHNICAL_CUE";
})(SegmentType || (SegmentType = {}));
export var SegmentDetection;
(function (SegmentDetection) {
    SegmentDetection.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SegmentDetection || (SegmentDetection = {}));
export var SegmentTypeInfo;
(function (SegmentTypeInfo) {
    SegmentTypeInfo.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SegmentTypeInfo || (SegmentTypeInfo = {}));
export var GetSegmentDetectionResponse;
(function (GetSegmentDetectionResponse) {
    GetSegmentDetectionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetSegmentDetectionResponse || (GetSegmentDetectionResponse = {}));
export var GetTextDetectionRequest;
(function (GetTextDetectionRequest) {
    GetTextDetectionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetTextDetectionRequest || (GetTextDetectionRequest = {}));
export var TextDetectionResult;
(function (TextDetectionResult) {
    TextDetectionResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TextDetectionResult || (TextDetectionResult = {}));
export var GetTextDetectionResponse;
(function (GetTextDetectionResponse) {
    GetTextDetectionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetTextDetectionResponse || (GetTextDetectionResponse = {}));
export var IdempotentParameterMismatchException;
(function (IdempotentParameterMismatchException) {
    IdempotentParameterMismatchException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(IdempotentParameterMismatchException || (IdempotentParameterMismatchException = {}));
export var IndexFacesRequest;
(function (IndexFacesRequest) {
    IndexFacesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(IndexFacesRequest || (IndexFacesRequest = {}));
export var Reason;
(function (Reason) {
    Reason["EXCEEDS_MAX_FACES"] = "EXCEEDS_MAX_FACES";
    Reason["EXTREME_POSE"] = "EXTREME_POSE";
    Reason["LOW_BRIGHTNESS"] = "LOW_BRIGHTNESS";
    Reason["LOW_CONFIDENCE"] = "LOW_CONFIDENCE";
    Reason["LOW_FACE_QUALITY"] = "LOW_FACE_QUALITY";
    Reason["LOW_SHARPNESS"] = "LOW_SHARPNESS";
    Reason["SMALL_BOUNDING_BOX"] = "SMALL_BOUNDING_BOX";
})(Reason || (Reason = {}));
export var UnindexedFace;
(function (UnindexedFace) {
    UnindexedFace.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(UnindexedFace || (UnindexedFace = {}));
export var IndexFacesResponse;
(function (IndexFacesResponse) {
    IndexFacesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(IndexFacesResponse || (IndexFacesResponse = {}));
export var ServiceQuotaExceededException;
(function (ServiceQuotaExceededException) {
    ServiceQuotaExceededException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ServiceQuotaExceededException || (ServiceQuotaExceededException = {}));
export var ListCollectionsRequest;
(function (ListCollectionsRequest) {
    ListCollectionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListCollectionsRequest || (ListCollectionsRequest = {}));
export var ListCollectionsResponse;
(function (ListCollectionsResponse) {
    ListCollectionsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListCollectionsResponse || (ListCollectionsResponse = {}));
export var ListFacesRequest;
(function (ListFacesRequest) {
    ListFacesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListFacesRequest || (ListFacesRequest = {}));
export var ListFacesResponse;
(function (ListFacesResponse) {
    ListFacesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListFacesResponse || (ListFacesResponse = {}));
export var ListStreamProcessorsRequest;
(function (ListStreamProcessorsRequest) {
    ListStreamProcessorsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListStreamProcessorsRequest || (ListStreamProcessorsRequest = {}));
export var StreamProcessor;
(function (StreamProcessor) {
    StreamProcessor.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StreamProcessor || (StreamProcessor = {}));
export var ListStreamProcessorsResponse;
(function (ListStreamProcessorsResponse) {
    ListStreamProcessorsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ListStreamProcessorsResponse || (ListStreamProcessorsResponse = {}));
export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(NotificationChannel || (NotificationChannel = {}));
export var RecognizeCelebritiesRequest;
(function (RecognizeCelebritiesRequest) {
    RecognizeCelebritiesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RecognizeCelebritiesRequest || (RecognizeCelebritiesRequest = {}));
export var RecognizeCelebritiesResponse;
(function (RecognizeCelebritiesResponse) {
    RecognizeCelebritiesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RecognizeCelebritiesResponse || (RecognizeCelebritiesResponse = {}));
export var SearchFacesRequest;
(function (SearchFacesRequest) {
    SearchFacesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SearchFacesRequest || (SearchFacesRequest = {}));
export var SearchFacesResponse;
(function (SearchFacesResponse) {
    SearchFacesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SearchFacesResponse || (SearchFacesResponse = {}));
export var SearchFacesByImageRequest;
(function (SearchFacesByImageRequest) {
    SearchFacesByImageRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SearchFacesByImageRequest || (SearchFacesByImageRequest = {}));
export var SearchFacesByImageResponse;
(function (SearchFacesByImageResponse) {
    SearchFacesByImageResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SearchFacesByImageResponse || (SearchFacesByImageResponse = {}));
export var Video;
(function (Video) {
    Video.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Video || (Video = {}));
export var StartCelebrityRecognitionRequest;
(function (StartCelebrityRecognitionRequest) {
    StartCelebrityRecognitionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartCelebrityRecognitionRequest || (StartCelebrityRecognitionRequest = {}));
export var StartCelebrityRecognitionResponse;
(function (StartCelebrityRecognitionResponse) {
    StartCelebrityRecognitionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartCelebrityRecognitionResponse || (StartCelebrityRecognitionResponse = {}));
export var VideoTooLargeException;
(function (VideoTooLargeException) {
    VideoTooLargeException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VideoTooLargeException || (VideoTooLargeException = {}));
export var StartContentModerationRequest;
(function (StartContentModerationRequest) {
    StartContentModerationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartContentModerationRequest || (StartContentModerationRequest = {}));
export var StartContentModerationResponse;
(function (StartContentModerationResponse) {
    StartContentModerationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartContentModerationResponse || (StartContentModerationResponse = {}));
export var StartFaceDetectionRequest;
(function (StartFaceDetectionRequest) {
    StartFaceDetectionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartFaceDetectionRequest || (StartFaceDetectionRequest = {}));
export var StartFaceDetectionResponse;
(function (StartFaceDetectionResponse) {
    StartFaceDetectionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartFaceDetectionResponse || (StartFaceDetectionResponse = {}));
export var StartFaceSearchRequest;
(function (StartFaceSearchRequest) {
    StartFaceSearchRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartFaceSearchRequest || (StartFaceSearchRequest = {}));
export var StartFaceSearchResponse;
(function (StartFaceSearchResponse) {
    StartFaceSearchResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartFaceSearchResponse || (StartFaceSearchResponse = {}));
export var StartLabelDetectionRequest;
(function (StartLabelDetectionRequest) {
    StartLabelDetectionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartLabelDetectionRequest || (StartLabelDetectionRequest = {}));
export var StartLabelDetectionResponse;
(function (StartLabelDetectionResponse) {
    StartLabelDetectionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartLabelDetectionResponse || (StartLabelDetectionResponse = {}));
export var StartPersonTrackingRequest;
(function (StartPersonTrackingRequest) {
    StartPersonTrackingRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartPersonTrackingRequest || (StartPersonTrackingRequest = {}));
export var StartPersonTrackingResponse;
(function (StartPersonTrackingResponse) {
    StartPersonTrackingResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartPersonTrackingResponse || (StartPersonTrackingResponse = {}));
export var StartProjectVersionRequest;
(function (StartProjectVersionRequest) {
    StartProjectVersionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartProjectVersionRequest || (StartProjectVersionRequest = {}));
export var StartProjectVersionResponse;
(function (StartProjectVersionResponse) {
    StartProjectVersionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartProjectVersionResponse || (StartProjectVersionResponse = {}));
export var StartShotDetectionFilter;
(function (StartShotDetectionFilter) {
    StartShotDetectionFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartShotDetectionFilter || (StartShotDetectionFilter = {}));
export var StartTechnicalCueDetectionFilter;
(function (StartTechnicalCueDetectionFilter) {
    StartTechnicalCueDetectionFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartTechnicalCueDetectionFilter || (StartTechnicalCueDetectionFilter = {}));
export var StartSegmentDetectionFilters;
(function (StartSegmentDetectionFilters) {
    StartSegmentDetectionFilters.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartSegmentDetectionFilters || (StartSegmentDetectionFilters = {}));
export var StartSegmentDetectionRequest;
(function (StartSegmentDetectionRequest) {
    StartSegmentDetectionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartSegmentDetectionRequest || (StartSegmentDetectionRequest = {}));
export var StartSegmentDetectionResponse;
(function (StartSegmentDetectionResponse) {
    StartSegmentDetectionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartSegmentDetectionResponse || (StartSegmentDetectionResponse = {}));
export var StartStreamProcessorRequest;
(function (StartStreamProcessorRequest) {
    StartStreamProcessorRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartStreamProcessorRequest || (StartStreamProcessorRequest = {}));
export var StartStreamProcessorResponse;
(function (StartStreamProcessorResponse) {
    StartStreamProcessorResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartStreamProcessorResponse || (StartStreamProcessorResponse = {}));
export var StartTextDetectionFilters;
(function (StartTextDetectionFilters) {
    StartTextDetectionFilters.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartTextDetectionFilters || (StartTextDetectionFilters = {}));
export var StartTextDetectionRequest;
(function (StartTextDetectionRequest) {
    StartTextDetectionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartTextDetectionRequest || (StartTextDetectionRequest = {}));
export var StartTextDetectionResponse;
(function (StartTextDetectionResponse) {
    StartTextDetectionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartTextDetectionResponse || (StartTextDetectionResponse = {}));
export var StopProjectVersionRequest;
(function (StopProjectVersionRequest) {
    StopProjectVersionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StopProjectVersionRequest || (StopProjectVersionRequest = {}));
export var StopProjectVersionResponse;
(function (StopProjectVersionResponse) {
    StopProjectVersionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StopProjectVersionResponse || (StopProjectVersionResponse = {}));
export var StopStreamProcessorRequest;
(function (StopStreamProcessorRequest) {
    StopStreamProcessorRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StopStreamProcessorRequest || (StopStreamProcessorRequest = {}));
export var StopStreamProcessorResponse;
(function (StopStreamProcessorResponse) {
    StopStreamProcessorResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StopStreamProcessorResponse || (StopStreamProcessorResponse = {}));
//# sourceMappingURL=models_0.js.map